export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-lg font-heading font-bold text-background-50 mb-3">
              屁屁影院
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              电视剧全集免费在线观看平台，不缓冲高清秒播，最新热播剧集同步更新。电影大片免费看，每天更新海量影视资源，高清流畅追剧无忧。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-3 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">专题合集</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门榜单</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">追剧快讯</a></li>
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">焦点专题</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-3 whitespace-nowrap">服务支持</h4>
            <ul className="space-y-2">
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a></li>
              <li><a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a></li>
              <li><a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">平台特色</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-3 whitespace-nowrap">合作伙伴</h4>
            <p className="text-sm text-background-500">诚邀优质内容方与平台合作，共创影视生态。</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 屁屁影院。本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">使用条款</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}